export const overseasWarehouseProducts = [
  {
    id: "owp1",
    name: "Premium Stainless Steel Cookware Set 12-Piece",
    category: "Kitchen & Home",
    price: 89.99,
    originalPrice: 149.99,
    commission: 1.80,
    image: "https://public.readdy.ai/ai/img_res/549919b8b8581fa041a8483df2cbc854.jpg",
    supplier: "SteelCraft USA Warehouse",
    supplierFlag: "🇺🇸",
    location: "Los Angeles, CA",
    stock: 248,
    sold: 1420,
    rating: 4.8,
    reviews: 312,
    shipsIn: "1-3 days",
    badge: "Best Seller",
    badgeColor: "bg-[#C41E3A]",
    description: "Professional-grade 18/10 stainless steel. Oven safe to 500°F. Dishwasher safe. Includes 6 pots, 4 pans, 2 lids.",
  },
  {
    id: "owp2",
    name: "Organic Cotton Bedding Set Queen Size",
    category: "Home & Bedding",
    price: 64.99,
    originalPrice: 99.99,
    commission: 1.30,
    image: "https://readdy.ai/api/search-image?query=luxury%20organic%20cotton%20bedding%20set%20queen%20size%20white%20and%20beige%20colors%2C%20neatly%20folded%20on%20white%20background%2C%20soft%20texture%20visible%2C%20elegant%20home%20textile%20product%20photography&width=400&height=300&seq=owp2&orientation=landscape",
    supplier: "PureSleep Warehouse",
    supplierFlag: "🇺🇸",
    location: "New York, NY",
    stock: 185,
    sold: 876,
    rating: 4.9,
    reviews: 204,
    shipsIn: "1-2 days",
    badge: "Top Rated",
    badgeColor: "bg-[#D4AF37]",
    description: "100% GOTS certified organic cotton. 400 thread count. Includes duvet cover, 2 pillowcases, fitted sheet.",
  },
  {
    id: "owp3",
    name: "Wireless Bluetooth Noise-Cancelling Headphones",
    category: "Electronics",
    price: 79.99,
    originalPrice: 129.99,
    commission: 1.60,
    image: "https://readdy.ai/api/search-image?query=premium%20wireless%20bluetooth%20noise%20cancelling%20headphones%20matte%20black%20on%20white%20background%2C%20over%20ear%20design%2C%20modern%20minimalist%20product%20photography%20with%20clean%20studio%20lighting&width=400&height=300&seq=owp3&orientation=landscape",
    supplier: "TechHub Warehouse",
    supplierFlag: "🇺🇸",
    location: "Chicago, IL",
    stock: 320,
    sold: 2150,
    rating: 4.7,
    reviews: 589,
    shipsIn: "1-3 days",
    badge: "Hot Deal",
    badgeColor: "bg-orange-500",
    description: "40hr battery life. Active noise cancellation. Foldable design. USB-C fast charging. Compatible with all devices.",
  },
  {
    id: "owp4",
    name: "Vitamin C Serum + Hyaluronic Acid Face Care Set",
    category: "Beauty & Skincare",
    price: 34.99,
    originalPrice: 59.99,
    commission: 0.70,
    image: "https://readdy.ai/api/search-image?query=vitamin%20c%20serum%20and%20hyaluronic%20acid%20skincare%20set%20glass%20bottles%20on%20white%20marble%20background%2C%20luxury%20beauty%20product%20photography%2C%20clean%20minimal%20aesthetic%20with%20soft%20natural%20lighting&width=400&height=300&seq=owp4&orientation=landscape",
    supplier: "GlowLab Warehouse",
    supplierFlag: "🇺🇸",
    location: "Miami, FL",
    stock: 412,
    sold: 3280,
    rating: 4.9,
    reviews: 847,
    shipsIn: "1-2 days",
    badge: "Best Seller",
    badgeColor: "bg-[#C41E3A]",
    description: "20% Vitamin C + 2% Hyaluronic Acid. Dermatologist tested. Cruelty-free. Brightens and firms skin in 4 weeks.",
  },
  {
    id: "owp5",
    name: "Adjustable Dumbbell Set 5-50 lbs",
    category: "Sports & Fitness",
    price: 149.99,
    originalPrice: 229.99,
    commission: 3.00,
    image: "https://readdy.ai/api/search-image?query=adjustable%20dumbbell%20set%205%20to%2050%20pounds%20on%20white%20background%2C%20modern%20fitness%20equipment%2C%20chrome%20and%20black%20design%2C%20professional%20product%20photography%20with%20clean%20studio%20lighting&width=400&height=300&seq=owp5&orientation=landscape",
    supplier: "FitGear Warehouse",
    supplierFlag: "🇺🇸",
    location: "Dallas, TX",
    stock: 96,
    sold: 654,
    rating: 4.8,
    reviews: 178,
    shipsIn: "2-4 days",
    badge: "New Arrival",
    badgeColor: "bg-green-600",
    description: "Replaces 15 sets of weights. Quick-adjust dial system. Non-slip grip. Includes storage tray. 2-year warranty.",
  },
  {
    id: "owp6",
    name: "Smart LED Desk Lamp with Wireless Charger",
    category: "Electronics",
    price: 44.99,
    originalPrice: 74.99,
    commission: 0.90,
    image: "https://readdy.ai/api/search-image?query=modern%20smart%20LED%20desk%20lamp%20with%20wireless%20charging%20pad%20base%2C%20sleek%20white%20design%20on%20white%20background%2C%20minimalist%20office%20accessory%2C%20clean%20product%20photography%20with%20soft%20studio%20lighting&width=400&height=300&seq=owp6&orientation=landscape",
    supplier: "SmartHome Warehouse",
    supplierFlag: "🇺🇸",
    location: "Seattle, WA",
    stock: 267,
    sold: 1890,
    rating: 4.6,
    reviews: 423,
    shipsIn: "1-3 days",
    badge: "Top Rated",
    badgeColor: "bg-[#D4AF37]",
    description: "5 color modes, 10 brightness levels. 15W Qi wireless charging. USB-A port. Touch control. Memory function.",
  },
  {
    id: "owp7",
    name: "Insulated Stainless Steel Water Bottle 32oz",
    category: "Kitchen & Home",
    price: 24.99,
    originalPrice: 39.99,
    commission: 0.50,
    image: "https://readdy.ai/api/search-image?query=insulated%20stainless%20steel%20water%20bottle%2032oz%20matte%20finish%20multiple%20colors%20on%20white%20background%2C%20outdoor%20sports%20bottle%2C%20clean%20minimal%20product%20photography%20with%20studio%20lighting&width=400&height=300&seq=owp7&orientation=landscape",
    supplier: "EcoVault Warehouse",
    supplierFlag: "🇺🇸",
    location: "Denver, CO",
    stock: 580,
    sold: 4120,
    rating: 4.9,
    reviews: 1024,
    shipsIn: "1-2 days",
    badge: "Best Seller",
    badgeColor: "bg-[#C41E3A]",
    description: "Triple-wall vacuum insulation. Keeps cold 48hr, hot 24hr. BPA-free. Leak-proof lid. Fits most cup holders.",
  },
  {
    id: "owp8",
    name: "Yoga Mat Premium Non-Slip 6mm Thick",
    category: "Sports & Fitness",
    price: 29.99,
    originalPrice: 49.99,
    commission: 0.60,
    image: "https://readdy.ai/api/search-image?query=premium%20yoga%20mat%206mm%20thick%20non-slip%20surface%20rolled%20and%20flat%20on%20white%20background%2C%20teal%20and%20purple%20colors%2C%20fitness%20equipment%20product%20photography%20with%20clean%20studio%20lighting&width=400&height=300&seq=owp8&orientation=landscape",
    supplier: "ZenFit Warehouse",
    supplierFlag: "🇺🇸",
    location: "Los Angeles, CA",
    stock: 340,
    sold: 2760,
    rating: 4.8,
    reviews: 612,
    shipsIn: "1-3 days",
    badge: "Hot Deal",
    badgeColor: "bg-orange-500",
    description: "Eco-friendly TPE material. 72\" x 24\" x 6mm. Alignment lines. Carrying strap included. Sweat-resistant surface.",
  },
];

export const overseasCategories = [
  "All Products",
  "Electronics",
  "Kitchen & Home",
  "Beauty & Skincare",
  "Sports & Fitness",
  "Home & Bedding",
];

export const overseasWarehouseLocations = [
  { city: "Los Angeles", state: "CA", products: 12400 },
  { city: "New York", state: "NY", products: 9800 },
  { city: "Chicago", state: "IL", products: 7600 },
  { city: "Dallas", state: "TX", products: 6200 },
  { city: "Miami", state: "FL", products: 5400 },
  { city: "Seattle", state: "WA", products: 4100 },
];
